import { render } from "./MovementsManager.vue?vue&type=template&id=78e3972b&scoped=true"
import script from "./MovementsManager.vue?vue&type=script&lang=js"
export * from "./MovementsManager.vue?vue&type=script&lang=js"

import "./MovementsManager.vue?vue&type=style&index=0&id=78e3972b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e3972b"]])

export default __exports__